<mobile-drawer
    [isDrawerOpen]="showIosInstallDrawer"
    (onOutsideClick)="closeIosInstallDrawer.emit(false)"
    [showCloseIcon]="true"
>
    <section class="ios-nudge-container">
        <img
            alt="Uniqode Cards logo"
            src="../../../assets/img/black-uniqode-logo.svg"
        />
        <div class="ios-nudge-heading">Uniqode Cards</div>
        <div class="ios-nudge-text">
            Add to your phone’s home screen for easy access to your digital
            business cards on the go.
        </div>
        <div class="ios-install-instructions">
            <div class="pb-4 d-flex">
                <span class="ios-nudge-text">1.</span>
                <div class="instruction">
                    <span class="ios-nudge-text">Tap the</span>
                    <span class="ios-bold-text">Share</span>
                    <span class="ios-nudge-text">icon (</span>
                    <svg
                        class="install-icon"
                        xmlns="http://www.w3.org/2000/svg"
                        width="13"
                        height="16"
                        viewBox="0 0 13 16"
                        fill="none"
                    >
                        <path
                            d="M6.28799 10.4493C6.59282 10.4493 6.85512 10.1941 6.85512 9.89632V2.61586L6.81258 1.5525L7.28755 2.05583L8.36509 3.20425C8.46433 3.31768 8.60611 3.37439 8.7479 3.37439C9.03855 3.37439 9.2654 3.16172 9.2654 2.87107C9.2654 2.7222 9.20159 2.60877 9.09526 2.50244L6.69916 0.191405C6.55738 0.0496234 6.43686 0 6.28799 0C6.14621 0 6.0257 0.0496234 5.87683 0.191405L3.48073 2.50244C3.37439 2.60877 3.31768 2.7222 3.31768 2.87107C3.31768 3.16172 3.53035 3.37439 3.82809 3.37439C3.96278 3.37439 4.11874 3.31768 4.21799 3.20425L5.28844 2.05583L5.77049 1.5525L5.72796 2.61586V9.89632C5.72796 10.1941 5.98316 10.4493 6.28799 10.4493ZM2.22596 16H10.3571C11.8387 16 12.5831 15.2627 12.5831 13.8024V6.72751C12.5831 5.26717 11.8387 4.52991 10.3571 4.52991H8.37926V5.67125H10.3358C11.0377 5.67125 11.4417 6.05405 11.4417 6.79132V13.7386C11.4417 14.4759 11.0377 14.8587 10.3358 14.8587H2.24014C1.53124 14.8587 1.14134 14.4759 1.14134 13.7386V6.79132C1.14134 6.05405 1.53124 5.67125 2.24014 5.67125H4.20381V4.52991H2.22596C0.744351 4.52991 0 5.26717 0 6.72751V13.8024C0 15.2627 0.744351 16 2.22596 16Z"
                            fill="#52565B"
                        />
                    </svg>
                    <span class="ios-nudge-text">) on your browser</span>
                </div>
            </div>
            <div class="d-flex">
                <span class="ios-nudge-text">2.</span>
                <div class="instruction">
                    <span class="ios-nudge-text">In the menu, tap</span>
                    <span class="ios-bold-text no-padding"
                        >Add to Home Screen</span
                    >
                    <span class="ios-nudge-text">, and then tap</span>
                    <span class="ios-bold-text">Add</span>
                </div>
            </div>
        </div>
    </section>
</mobile-drawer>
